import { defineComponent, computed } from "@vue/composition-api";
import { JSConn } from "@/utilities/js-conn";
import { map as Rmap } from "ramda";
import { buildSubmitButton } from "@/utilities/form-helpers";

import { CWorkOrderTask } from "@/store/modules/workOrderTasks";

import { buildFormEditTask } from "@/models/WorkOrderTask";

import StatusIndicator from "@/components/StatusIndicator/StatusIndicator.vue";

export default defineComponent({
  name: "mWorkOrderTasks",
  components: {
    StatusIndicator,
  },
  props: {
    workOrderId: {
      type: String,
      required: true,
    },
  },

  setup(_props, ctx) {
    const $store = ctx.root.$store;

    const workOrder = computed(() => {
      return $store.getters.workOrder;
    });

    let { submitButtonText, submitting } = buildSubmitButton();

    submitButtonText.value = "Complete";

    let {
      editingTask,
      editTask,
      editingTaskId,
      cancelEditTask,
    } = buildFormEditTask();

    const localEditTask = (task: CWorkOrderTask) => {
      if (task.status === "completed") {
        return editTask("edit", editingTaskId, editingTask, task);
      } else {
        return editTask("complete", editingTaskId, editingTask, task);
      }
    };

    const localCancelEditTask = (task: CWorkOrderTask) => {
      return cancelEditTask(editingTaskId, task);
    };

    const submitEditTask = (evt: any) => {
      evt.preventDefault();
      submitButtonText.value = "Completing...";
      submitting.value = true;

      const jsConnWorkOrderTask = new JSConn();

      jsConnWorkOrderTask.formParams = {
        id: editingTask.id,
        status: editingTask.status,
        start_date: editingTask.start_date,
        completed_date: editingTask.completed_date,
      };

      let jsConnTaskLineItems = Rmap(item => {
        const tempJsConn = new JSConn();
        tempJsConn.formParams = {
          id: item.id,
          quantity: item.quantity,
          item_date: editingTask.completed_date,
        };

        return $store.dispatch("updateWorkOrderTaskLineItem", tempJsConn);
      }, editingTask.work_order_task_line_items);

      const dataPromises = [
        $store.dispatch("completeWorkOrderTask", jsConnWorkOrderTask),
        ...jsConnTaskLineItems,
      ];

      Promise.all(dataPromises).then(() => {
        editingTaskId.value = "";
        submitButtonText.value = "Complete";
        submitting.value = false;
        // tell the parent that the data has changed
        ctx.emit("tasksChanged");
        return Promise.resolve();
      });
    };

    return {
      workOrder,

      localEditTask,
      localCancelEditTask,

      editingTaskId,
      editingTask,
      submitEditTask,
      submitButtonText,
      submitting,
    };
  },
});
